import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './Accordion.module.scss'
import parse from 'html-react-parser'
import cx from 'classnames'
import { fireAnalyticsEvent } from '~analyticsUtils'
import { RichTextType } from '~types'
import { useSmoothAnchorScroll } from 'utils/hooks/useSmoothAnchorScroll'

export interface AccordionProps {
  title: string
  description: RichTextType
  anchorId?: string
}

const Accordion = ({ title, description, anchorId }: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const { asPath } = useRouter()
  const { ref } = anchorId ? useSmoothAnchorScroll(anchorId) : { ref: undefined }
  const linkModule = 'accordion'

  const handleToggle = () => {
    const newState = !isOpen
    setIsOpen(newState)

    const action = newState ? 'open' : 'close'
    fireAnalyticsEvent(null, asPath, {
      clickTracking: `${linkModule}:${title}:${action}`,
      linkModule: linkModule
    })

    if (newState && anchorId) {
      window.history.replaceState(null, '', `#${anchorId}`)
    }
  }

  useEffect(() => {
    if (anchorId && window.location.hash === `#${anchorId}`) {
      setIsOpen(true)
    }
  }, [anchorId])

  if (!title || !description) return null

  return (
    <div ref={ref} className={styles['accordion-container']} {...(anchorId ? { id: anchorId } : {})}>
      <div className={styles['accordion-item']}>
        <div className={styles['accordion-header']} onClick={handleToggle}>
          <span className={styles['accordion-title']}>{title}</span>
          <FontAwesomeIcon
            icon={faAngleDown}
            className={cx(styles['accordion-icon'], {
              [styles['rotated']]: isOpen
            })}
          />
        </div>
        {isOpen && description?.html && (
          <div className={styles['accordion-description']}>{parse(description.html)}</div>
        )}
        <hr className={styles['accordion-divider']} />
      </div>
    </div>
  )
}

export default Accordion
